module.exports = __webpack_public_path__ + "static/media/outline-icons.cd6c777f.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/outline-icons.woff2
// module id = 408
// module chunks = 0